"use client";

import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/lib/supabase';

const logo = new URL('../assets/amplyy.png', import.meta.url).href;

export default function MobileNav() {
  const [open, setOpen] = useState(false);
  const { isDark, toggleTheme } = useTheme();
  const { user } = useAuth();
  const location = useLocation();

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/create-campaign', label: 'Create Campaign' },
    { path: '/smart-links', label: 'Smart Links' },
    { path: '/fans', label: 'My Fans' },
    { path: '/guests', label: 'My Guests' },
    { path: '/campaigns', label: 'My Campaigns' },
    { path: '/affiliates', label: 'Affiliates' },
    { path: '/settings', label: 'Account Settings' },
  ];

  return (
    <div className="md:hidden sticky top-0 z-40 bg-white/80 dark:bg-black/80 backdrop-blur border-b border-slate-200 dark:border-gray-700">
      <div className="flex items-center justify-between px-4 h-14">
        <Link to="/dashboard" className="flex items-center gap-2">
          <img src={logo} alt="Amply" className="h-8 w-auto" />
        </Link>
        <div className="flex items-center gap-3">
          <button
            onClick={toggleTheme}
            aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
            className="h-8 w-8 inline-flex items-center justify-center rounded border border-white/20 dark:border-white/10 text-black dark:text-white hover:bg-black/5 dark:hover:bg-white/10 transition-colors"
          >
            {isDark ? <Sun size={16} /> : <Moon size={16} />}
          </button>
          <button
            onClick={() => setOpen(o => !o)}
            className="p-2 rounded-md border border-slate-300 dark:border-gray-600 text-black dark:text-white"
            aria-label="Toggle menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="px-4 pb-4 space-y-2 bg-white dark:bg-black border-t border-slate-200 dark:border-gray-700">
          {menuItems.map(item => {
            const active = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setOpen(false)}
                className={`block rounded-md px-3 py-2 text-sm font-medium transition-colors ${active ? 'bg-[#e3c5b3] text-white' : 'text-black dark:text-slate-300 hover:bg-[#e3c5b3] hover:text-white dark:hover:text-white'}`}
              >
                {item.label}
              </Link>
            );
          })}
          <div className="pt-2 flex gap-3">
            {user ? (
              <button
                onClick={async () => { await supabase.auth.signOut(); window.location.href = '/login'; }}
                className="flex-1 rounded-md bg-red-500/90 hover:bg-red-500 text-white text-sm py-2"
              >
                Log Out
              </button>
            ) : (
              <>
                <Link
                  to="/login"
                  onClick={() => setOpen(false)}
                  className="flex-1 rounded-md border border-slate-300 dark:border-gray-600 text-center py-2 text-sm text-black dark:text-white"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  onClick={() => setOpen(false)}
                  className="flex-1 rounded-md bg-[#e3c5b3] text-white text-center py-2 text-sm"
                >
                  Register
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
